import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CommonActionKey, HorizontalListData, IdentityVerificationFacade, IdentityVerificationSummary, MessageService, SimpleDialogComponent } from 'common';
import { CustomerIdentityVerificationWidgetAdapter, getSetToVerifiedDialogData, getStartKbaDialogData, getStartNewIdVerseDialogData, VerificationStatusLabels } from './customer-identity-verification-widget.data';
import { CustomerStatus } from '../../customer.model';

@Component({
    selector: 'ifb-customer-identity-verification-widget',
    templateUrl: './customer-identity-verification-widget.component.html',
    styleUrls: ['./customer-identity-verification-widget.component.scss'],
    providers: [CustomerIdentityVerificationWidgetAdapter],
    standalone: false
})
export class IdentityVerificationWidgetComponent implements OnChanges {
  @Input()
  identityVerification: IdentityVerificationSummary;

  @Input()
  customerId: number;

  @Input()
  canUseActionLinks: boolean;

  @Input()
  canEditManually: boolean;

  @Input()
  customerStatus: CustomerStatus;

  @Output()
  refreshCustomerData: EventEmitter<void>;

  listItems: HorizontalListData[];
  readonly VerificationStatusLabels = VerificationStatusLabels;

  constructor(
    private readonly adapter: CustomerIdentityVerificationWidgetAdapter,
    private readonly identityVerificationFacade: IdentityVerificationFacade,
    private readonly dialog: MatDialog,
    private readonly messageService: MessageService,
  ) {
    this.refreshCustomerData = new EventEmitter<void>();
  }

  ngOnChanges(): void {
    this.listItems = this.adapter.adaptListData(this.identityVerification, this.canUseActionLinks, this.customerStatus);
  }

  onStartKbaVerification(): void {
    SimpleDialogComponent.show(this.dialog, getStartKbaDialogData()).subscribe((result: string) => {
      if (result === CommonActionKey.Confirm) {
        this.identityVerificationFacade.startNewKba(this.customerId).subscribe(() => {
          this.messageService.success('New KBA verification initiated');
          this.refreshCustomerData.emit();
        });
      }
    });
  }

  onStartNewIdVerseVerification(): void {
    SimpleDialogComponent.show(this.dialog, getStartNewIdVerseDialogData()).subscribe((result: string) => {
      if (result === CommonActionKey.Confirm) {
        this.identityVerificationFacade.startNewIdVerse(this.customerId).subscribe(() => {
          this.messageService.success('New IDVerse verification initiated');
          this.refreshCustomerData.emit();
        });
      }
    });
  }

  onSetToVerified(): void {
    SimpleDialogComponent.show(this.dialog, getSetToVerifiedDialogData()).subscribe((result: string) => {
      if (result === CommonActionKey.Confirm) {
        this.identityVerificationFacade.setVerified(this.customerId).subscribe(() => {
          this.messageService.success('Status set to Verified');
          this.refreshCustomerData.emit();
        });
      }
    });
  }
}